/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import { FormikContextType } from 'formik';

import { EAutoReportIdFormatField as Field, IAutoReportIdFormatFields } from '../types';

type TClearCallbacks = Pick<FormikContextType<IAutoReportIdFormatFields>,
    'setFieldValue' | 'setFieldTouched' | 'validateForm'>

export const onSendByEmailFieldChange = ({ setFieldTouched, setFieldValue, validateForm }: TClearCallbacks) => {
    [Field.SendByEmailZip].forEach(key => {
        setFieldValue(key, false, false);
        setFieldTouched(key, false, false);
    });
    onSendByEmailZipChange({ setFieldTouched, setFieldValue, validateForm })
};

export const onSendByEmailZipChange = ({ setFieldTouched, setFieldValue, validateForm }: TClearCallbacks) => {
    [Field.SendByEmailZipPasswordEnabled].forEach(key => {
        setFieldValue(key, false, false);
        setFieldTouched(key, false, false);
    });
    [Field.SendByEmailZipPassword].forEach(key => {
        setFieldValue(key, '', false);
        setFieldTouched(key, false, false);
    });

    setTimeout(() => {
        validateForm();
    })
}
